// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Ex0N","paramInput":"JobSimulator_paramInput__1hqGK","input":"JobSimulator_input__2ylK2"};